import { render, staticRenderFns } from "./AccountBalance.vue?vue&type=template&id=51cc882a&scoped=true"
import script from "./AccountBalance.vue?vue&type=script&lang=js"
export * from "./AccountBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cc882a",
  null
  
)

export default component.exports